// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"63640241","453":"90be889d","455":"504a4d24","977":"eba4d124"}[chunkId] + ".chunk.js";
};